export const CATEGORIES = [
    { id: 1, name: 'Fashion', color: '#ffcc00' },
    { id: 2, name: 'Pro Night', color: '#8a2be2' }, // Was Live Events
    { id: 3, name: 'Theatre', color: '#32cd32' },
    { id: 4, name: 'Music', color: '#00ffff' },
    { id: 5, name: 'Dance', color: '#ff007f' },
    { id: 6, name: 'Creative Corners', color: '#ffffff' }, // Was Fine Arts
];
